import {
  Typography,
  Box,
  Button,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Card,
  CardContent,
  Paper,
  useMediaQuery,
  Modal,
  TextField,
  IconButton,
  Select,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from "react";
import "./event_payment.css";
import { useNavigate, useParams } from "react-router-dom";
import TextInput from "../../../components/TextInput/TextInput";
import { useForm } from "react-hook-form";
import getEventController from "../Controller/getEvent_controller";
import SelectInput from "../../../components/TextInput/SelectInput";

//icon
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";

const EventPayment = () => {
  const { eventId } = useParams(); // Get the event ID from URL
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const [memberList, setMemberList] = useState([]); // State to store member data
  const [openModal, setOpenModal] = useState(false);
  const [publicParticipants, setPublicParticipants] = useState([]);
  const [participantInfo, setParticipantInfo] = useState({
    salutation: "",
    name: "",
    ic: "",
    email: "",
    phone: "",
    designation: "",
    RPM_No: "",
    dietary_option: "",
  });
  const [eventData, setEventData] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]); // Track selected checkboxes
  const [totalAmount, setTotalAmount] = useState(0); // Total payment amount
  const normal_rate = eventData?.normal_rate || 0; // Get price from database

  const [openDietaryModal, setOpenDietaryModal] = useState(false);
  const [selectedUserID, setSelectedUserID] = useState(null);
  const [selectedDietaryOption, setSelectedDietaryOption] = useState("");

  // Handle checkbox toggle
  const handleCheckboxChange = (userID) => {
    const isAlreadySelected = selectedMembers.some(
      (member) => member.userID === userID
    );

    if (isAlreadySelected) {
      // Remove user if checkbox is unchecked
      setSelectedMembers((prev) =>
        prev.filter((member) => member.userID !== userID)
      );
    } else {
      // Open modal before adding user
      setSelectedUserID(userID);
      setOpenDietaryModal(true);
    }
  };

  const handleConfirmDietarySelection = () => {
    setSelectedMembers((prev) => [
      ...prev,
      { userID: selectedUserID, dietaryOption: selectedDietaryOption },
    ]);
    setOpenDietaryModal(false); // Close modal
    setSelectedUserID(null); // Reset user ID
    setSelectedDietaryOption(""); // Reset selection
  };

  // Open Modal
  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Handle Input Change
  const handleInputChange = (e, name) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setParticipantInfo((prev) => ({ ...prev, [name]: value }));
      setMemberInfo((prev) => ({ ...prev, [name]: value }));
    } else {
      // Handle MUI Select case where e is the value
      setParticipantInfo((prev) => ({ ...prev, [name]: e }));
      setMemberInfo((prev) => ({ ...prev, [name]: e }));
    }
  };

  // Add Participant
  const handleAddParticipant = () => {
    setPublicParticipants((prev) => [...prev, participantInfo]);
    setParticipantInfo({
      salutation: "",
      name: "",
      ic: "",
      email: "",
      phone: "",
      designation: "",
      RPM_No: "",
      dietary_option: "",
    }); // Reset form
    handleCloseModal(); // Close modal
  };

  // Remove Participant
  const handleRemoveParticipant = (indexToRemove) => {
    setPublicParticipants((prevParticipants) =>
      prevParticipants.filter((_, index) => index !== indexToRemove)
    );
  };

  // Calculate total amount dynamically
  useEffect(() => {
    const memberCount = selectedMembers.length;
    const participantCount = publicParticipants.length;
    const total_pax = memberCount + participantCount;
    const total = normal_rate * total_pax;
    setTotalAmount(total);
  }, [selectedMembers, publicParticipants, normal_rate]);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      eventName: "",
      description: "",
      venue: "",
      poster: "",
      earlyBirdStartDate: "",
      earlyBirdEndDate: "",
      registrationStartDate: "",
      registrationEndDate: "",
      eventStartDateTime: "",
      eventEndDateTime: "",
      earlyBirdPrice: "",
      registrationPrice: "",
      numberOfPax: "",
      eventCategory: "",
    },
  });

  const memberId = localStorage.getItem("memberId"); // Fetch the stored memberId
  const email = localStorage.getItem("email"); // Fetch the stored email
  const member_type = localStorage.getItem("member_type"); // Fetch the stored member_type
  // console.log(memberId);
  // console.log(email);
  // console.log(member_type);

  const [MemberInfo, setMemberInfo] = useState({
    memberId: memberId, // get memberId from local storage
    userID: "",
    contact_person_salutation: "",
    membername: "",
    email: email,
    phone: "",
    company_name: "",
    billing_address: "",
    TIN_NO: "",
    office_tel_no: "",
    hrd_corp_grant: "",
  });

  //get Member Info by MemberID and Email
  useEffect(() => {
    getEventController
      .getMemberInfo(memberId, email)
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure

        // Set eventData directly from the response object
        if (response) {
          setMemberInfo({
            userID: response.userID,
            contact_person_salutation: response.salutation,
            membername: response.name,
            email: response,
            email,
            memberId: response,
            memberId,
            address: response.address,
            place_of_birth: response.place_of_birth,
            phone: response.handphone_no,
            race: response.race,
            gender: response.gender,
            nationality: response.nationality,
            marital_status: response.marital_status,
            academic_qualification: response.academic_qualification,
            office_email: response.office_email,
            office_tel: response.office_tel_no,
            fax_no: response.fax,
            nature_of_work: response.nature_of_work,
            years_with_company: response.years_with_company,
            company_name: response.company_name,
            billing_address: response.correspondence_address,
            TIN_NO: response.e_invoice_pin,
            office_tel_no: response.office_tel_no,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId]);

  //get Member by MemberID
  useEffect(() => {
    if (!memberId) {
      console.error("Member ID is missing");
      return;
    }

    getEventController
      .getMembersbyMemberId(memberId)
      .then((response) => {
        if (Array.isArray(response)) {
          console.log("API Response:", response); // Log the API response to check structure

          // Map response to the desired structure
          const memberData = response.map((item) => ({
            userID: item.userID,
            membername: item.name,
            email: item.email,
            memberId: item.memberId,
            address: item.address,
            place_of_birth: item.place_of_birth,
            phone: item.handphone_no,
            race: item.race,
            gender: item.gender,
            nationality: item.nationality,
            marital_status: item.marital_status,
            academic_qualification: item.academic_qualification,
            profile_image: item.profile_image,
            office_email: item.office_email,
            office_tel: item.office_tel_no,
            fax_no: item.fax,
            nature_of_work: item.nature_of_work,
            years_with_company: item.years_with_company,
          }));

          setMemberList(memberData); // Update state with the member data
        } else {
          console.error("Unexpected API response format:", response);
        }
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
      });
  }, [memberId]);

  //get Event by EventID
  // useEffect(() => {
  //   getEventController
  //     .getEventDetails({ eventId })
  //     .then((response) => {
  //       // console.log("API Response:", response); // Log to verify the response structure

  //       // Set eventData directly from the response object
  //       if (response) {
  //         const startDate = new Date(response.event_start_datetime);
  //         const endDate = new Date(response.event_end_datetime);

  //         // Format the dates as "DD-MMM-YYYY"
  //         const dateFormatter = new Intl.DateTimeFormat("en-GB", {
  //           day: "2-digit",
  //           month: "short",
  //           year: "numeric",
  //         });

  //         setEventData({
  //           id: response.eventID,
  //           imgSrc: response.event_poster || "/path/to/default/image.jpg",
  //           title: response.event_name || "Untitled Event",
  //           startdate: response.event_start_datetime
  //             ? dateFormatter.format(startDate)
  //             : "Date not available",
  //           enddate: response.event_end_datetime
  //             ? dateFormatter.format(endDate)
  //             : "Date not available",
  //           venue: response.event_venue || "Venue not specified",
  //           description: response.event_desc || "No description available",
  //           registrationPrice: response.registration_price,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching event data:", error);
  //     });
  // }, [eventId]);

  //get EventPrice by EventID and Member_Type
  useEffect(() => {
    getEventController
      .getEventPrice({ eventId, member_type })
      .then((response) => {
        console.log("API Response:", response); // Log to verify the response structure
        // Set eventData directly from the response object
        if (response) {
          const startDate = new Date(response.event_start_datetime);
          const endDate = new Date(response.event_end_datetime);
          // Format the dates as "DD-MMM-YYYY"
          const dateFormatter = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
          setEventData({
            id: response.eventID,
            imgSrc: response.event_poster || "/path/to/default/image.jpg",
            title: response.event_name || "Untitled Event",
            startdate: response.event_start_datetime
              ? dateFormatter.format(startDate)
              : "Date not available",
            enddate: response.event_end_datetime
              ? dateFormatter.format(endDate)
              : "Date not available",
            venue: response.event_venue || "Venue not specified",
            description: response.event_desc || "No description available",
            eventFeeId: response.event_feeID,
            normal_rate: response.normal_rate,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching event data:", error);
      });
  }, [eventId]);

  const handleRegisterEvent = async () => {
    const memberCount = selectedMembers.length;
    const participantCount = publicParticipants.length;
    const total_pax = memberCount + participantCount;
    const checkedAccounts = selectedMembers.toString();
    const account_join = selectedMembers
      .map((account) => account.userID)
      .join(",");
    const account_dietary = selectedMembers
      .map((account) => account.dietaryOption)
      .join(",");
    // Group data by fields
    const salutations = publicParticipants
      .map((participant) => participant.salutation)
      .join(",");
    const names = publicParticipants
      .map((participant) => participant.name)
      .join(",");
    const ics = publicParticipants
      .map((participant) => participant.ic)
      .join(",");
    const emails = publicParticipants
      .map((participant) => participant.email)
      .join(",");
    const phones = publicParticipants
      .map((participant) => participant.phone)
      .join(",");
    const designations = publicParticipants
      .map((participant) => participant.designation)
      .join(",");
    const rpm_nos = publicParticipants
      .map((participant) => participant.RPM_No)
      .join(",");
    const dietary_options = publicParticipants
      .map((participant) => participant.dietary_option)
      .join(",");

    const data = {
      eventID: eventId,
      initiatorID: MemberInfo.userID,
      billingName: MemberInfo.company_name,
      billingAddress: MemberInfo.billing_address,
      TIN_No: MemberInfo.TIN_NO,
      contactSalutation: MemberInfo.contact_person_salutation,
      contactName: MemberInfo.membername,
      contactHP: MemberInfo.phone,
      contactEmail: MemberInfo.email,
      contactOfficeNo: MemberInfo.office_tel_no,
      hrd_corp_grant: MemberInfo.hrd_corp_grant,
      selectedAccounts: account_join,
      selectedAccountsDietary: account_dietary,
      publicParticipants_salutations: salutations,
      publicParticipants_names: names,
      publicParticipants_ids: ics,
      publicParticipants_emails: emails,
      publicParticipants_phones: phones,
      publicParticipants_designations: designations,
      publicParticipants_rpm_nos: rpm_nos,
      publicParticipants_dietary_options: dietary_options,
      itemIDs: eventData.eventFeeId,
      pax: total_pax,
      amounts: eventData.normal_rate,
    };

    // console.log(data);

    const response = await getEventController.RegisterEvent(data);
    if (response.success) {
      navigate(`/acknowledgement/${response.eventRegistrationID}`); // Redirect
    } else {
      alert(response.message);
    }
  };

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="event-payment">
          <Box sx={{ display: "flex" }}>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
              {/* <DrawerHeader /> */}
              {/* {showAlertSuccess && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {alertSuccessMsg}
            </Alert>
          )} */}

              <form>
                <div className="event-payment-form">
                  <Paper
                    sx={{
                      padding: "20px",
                      height: "auto",
                      width: "auto",
                      boxShadow: 5,
                      borderRadius: "15px",
                    }}
                  >
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={2} sx={{ marginBottom: "10px" }}>
                        {/* Name */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Name</label>
                          <input
                            name="membername"
                            className="ep-input form-control"
                            type="text"
                            placeholder="Name"
                            // value={MemberInfo.membername}
                            // onChange={handleInputChange}
                          />
                        </Grid>
                        {/* Email */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Email</label>
                          <input
                            name="email"
                            className="ep-input form-control"
                            type="email"
                            placeholder="Email"
                            // value={MemberInfo.email}
                            // readOnly
                            // disabled
                          />
                        </Grid>
                        {/* Phone */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Phone</label>
                          <input
                            name="phone"
                            className="ep-input form-control"
                            type="number"
                            placeholder="Phone Number"
                            // value={MemberInfo.phone}
                            // onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>
                      {/* Assign Accounts to Join */}
                      <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Assign Accounts to Join</label>
                        </Grid>
                      </Grid>
                      <div className="mb-4">
                        <MenuList
                          sx={{
                            padding: "12px",
                          }}
                        >
                          <MenuItem
                            className="mt-2"
                            sx={{
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              padding: "10px",
                              marginBottom: "10px",
                              "&:hover": {
                                backgroundColor: "white",
                                borderColor: "#b24743",
                              },
                            }}
                          >
                            <ListItemIcon>
                              <AccountCircleIcon
                                fontSize="large"
                                className="profile-icon"
                              />
                            </ListItemIcon>
                            <ListItemText>User 1</ListItemText>
                            <Checkbox></Checkbox>
                          </MenuItem>
                          <MenuItem
                            className="mt-2"
                            sx={{
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              padding: "10px",
                              marginBottom: "10px",
                              "&:hover": {
                                backgroundColor: "white",
                                borderColor: "#b24743",
                              },
                            }}
                          >
                            <ListItemIcon>
                              <AccountCircleIcon
                                fontSize="large"
                                className="profile-icon"
                              />
                            </ListItemIcon>
                            <ListItemText>User 2</ListItemText>
                            <Checkbox></Checkbox>
                          </MenuItem>
                        </MenuList>
                      </div>
                    </Box>
                  </Paper>
                  {/* payment details row */}
                  <div>
                    <div className="payment-details-row mt-2">
                      <Card
                        sx={{
                          boxShadow: 5,
                          borderRadius: "25px",
                          width: "100%",
                          display: "flex",
                        }}
                        className="d-flex"
                      >
                        <CardContent
                          sx={{
                            width: "100%",
                          }}
                        >
                          <span className="pd-label">Payment Details</span>
                          <div className="subtotal-container">
                            <span className="subtotal-label1">Subtotal</span>
                            <span className="subtotal-label2">
                              RM 250.00 x 2
                            </span>
                          </div>
                          <div className="total-container">
                            <span className="total-label">Total</span>
                            <span className="total-label">RM 500.00</span>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                    <div className="ep-button-container">
                      <button
                        className="ep-button1"
                        onClick={() => navigate("/acknowledgement")}
                      >
                        Generate Invoice
                      </button>
                      <button className="ep-button2">Proceed Payment</button>
                    </div>
                  </div>
                </div>
              </form>
            </Box>
          </Box>
        </div>
      ) : (
        <div className="event-payment">
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            {/* <span>BACK </span> */}
          </div>
          <Box component="form" sx={{ flexGrow: 1, p: 3 }}>
            <form>
              <div
                className="event-payment-form col-xl-12"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "20px", // Adds space between the columns
                  width: "100%",
                }}
              >
                <div className="col-xl-12">
                  <Card
                    sx={{
                      padding: "20px",
                      height: "auto",
                      maxWidth: "800px",
                      width: "auto",
                      boxShadow: 5,
                      borderRadius: "15px",
                      flexGrow: 1,
                    }}
                  >
                    <Box sx={{ flexGrow: 1 }}>
                      <Grid container spacing={2} sx={{ marginBottom: "15px" }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Billing Info
                        </Typography>
                        {/* Company Name */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Company Name</label>
                          <input
                            name="company_name"
                            className="ep-input form-control"
                            type="text"
                            placeholder="Company Name"
                            value={MemberInfo.company_name}
                            onChange={handleInputChange}
                          />
                        </Grid>
                        {/* Billing Address */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Billing Address</label>
                          <input
                            name="billing_address"
                            className="ep-input form-control"
                            type="text"
                            placeholder="Billing Address"
                            value={MemberInfo.billing_address}
                            onChange={handleInputChange}
                            // readOnly
                            // disabled
                          />
                        </Grid>
                        {/* E-Invoice/TIN No. */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>E-Invoice/TIN No.</label>
                          <input
                            name="TIN_NO"
                            className="ep-input form-control"
                            type="text"
                            placeholder="E-Invoice/TIN No."
                            value={MemberInfo.TIN_NO}
                            onChange={handleInputChange}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ marginBottom: "10px" }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Contact Person Info
                        </Typography>
                        {/* Salutation */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Salutation</label>
                          <input
                            className="ep-input form-control"
                            name="contact_person_salutation"
                            value={MemberInfo.contact_person_salutation || ""}
                            onChange={handleInputChange}
                          />
                        </Grid>
                        {/* Name */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Name</label>
                          <input
                            name="initiatorID"
                            value={MemberInfo.userID}
                            hidden
                          />
                          <input
                            name="membername"
                            className="ep-input form-control"
                            type="text"
                            placeholder="Name"
                            value={MemberInfo.membername}
                            onChange={handleInputChange}
                          />
                        </Grid>
                        {/* Email */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Email</label>
                          <input
                            name="email"
                            className="ep-input form-control"
                            type="email"
                            placeholder="Email"
                            value={MemberInfo.email}
                            onChange={handleInputChange}

                            // readOnly
                            // disabled
                          />
                        </Grid>
                        {/* Phone */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Mobile No.</label>
                          <input
                            name="phone"
                            className="ep-input form-control"
                            type="number"
                            placeholder="Phone Number"
                            value={MemberInfo.phone}
                            onChange={handleInputChange}
                          />
                        </Grid>
                        {/* Office No */}
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Office Tel No.</label>
                          <input
                            name="office_tel_no"
                            className="ep-input form-control"
                            type="number"
                            placeholder="Office No."
                            value={MemberInfo.office_tel_no}
                            onChange={handleInputChange}
                          />
                        </Grid>
                        {/* HRD Corp */}
                        <Grid item xs={12} md={12}>
                          <label>Are you applying for HRD Corp Grant?</label>
                          <Select
                            className="ep-input form-select"
                            name="hrd_corp_grant"
                            value={MemberInfo.hrd_corp_grant || ""}
                            onChange={(event) =>
                              handleInputChange(
                                event.target.value,
                                "hrd_corp_grant"
                              )
                            }
                          >
                            <MenuItem value="1">Yes</MenuItem>
                            <MenuItem value="0">No</MenuItem>
                          </Select>
                        </Grid>
                      </Grid>
                      {/* Assign Accounts to Join */}
                      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                          Participants Info
                        </Typography>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <label>Assign Accounts to Join</label>
                        </Grid>
                      </Grid>
                      <div className="mb-2">
                        <MenuList sx={{ padding: "12px" }}>
                          {memberList.map((member, index) => (
                            <MenuItem
                              key={index}
                              className="mt-2"
                              sx={{
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                backgroundColor: "white",
                                padding: "10px",
                                marginBottom: "10px",
                                "&:hover": {
                                  backgroundColor: "white",
                                  borderColor: "#b24743",
                                },
                              }}
                            >
                              <ListItemIcon>
                                {member.profile_image &&
                                member.profile_image.trim() !== "" ? (
                                  <img
                                    src={member.profile_image}
                                    className="ep-profile-icon"
                                    alt="Profile"
                                  />
                                ) : (
                                  <AccountCircleIcon
                                    className="ep-profile-icon"
                                    sx={{ fontSize: 40, color: "gray" }}
                                  />
                                )}
                              </ListItemIcon>
                              <ListItemText
                                sx={{
                                  marginLeft: "20px",
                                }}
                                primaryTypographyProps={{ fontSize: "18px" }}
                                primary={member.membername}
                                secondary={member.email}
                              />
                              <Checkbox
                                value={member.userID}
                                checked={selectedMembers.some(
                                  (m) => m.userID === member.userID
                                )}
                                onChange={() =>
                                  handleCheckboxChange(member.userID)
                                }
                              />
                            </MenuItem>
                          ))}
                        </MenuList>
                      </div>
                      {/* Add Public Participants Section */}
                      <Grid
                        container
                        spacing={2}
                        sx={{
                          marginTop: "10px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid item xs={12}>
                          <label>Other Participants</label>
                        </Grid>
                        <button
                          type="button"
                          className="add-button"
                          onClick={handleOpenModal}
                        >
                          Add New Other Participant
                        </button>
                      </Grid>
                      {/* Dynamic List of Participants */}
                      <MenuList sx={{ padding: "12px", marginTop: "10px" }}>
                        {publicParticipants.map((participant, index) => (
                          <MenuItem
                            key={index}
                            sx={{
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              padding: "10px",
                              marginBottom: "10px",
                              display: "flex",
                              justifyContent: "space-between", // Ensure space between text and button
                              alignItems: "center",
                              "&:hover": {
                                backgroundColor: "white",
                                borderColor: "#b24743",
                              },
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <ListItemIcon>
                                <AccountCircleIcon
                                  fontSize="large"
                                  className="profile-icon"
                                />
                              </ListItemIcon>
                              <ListItemText
                                data-ic={`${participant.ic}`}
                                primary={`${participant.name}`}
                                secondary={`IC: ${participant.ic}, Email: ${participant.email}, Phone: ${participant.phone}`}
                              />
                            </Box>
                            <IconButton
                              edge="end"
                              color="error"
                              onClick={() => handleRemoveParticipant(index)} // Function to remove participant
                            >
                              <RemoveCircleOutlinedIcon />
                            </IconButton>
                          </MenuItem>
                        ))}
                      </MenuList>
                    </Box>
                    <Button
                      onClick={() => handleRegisterEvent()}
                      className="next_button"
                      sx={{
                        width: "100%",
                        marginTop: "15px",
                        padding: "10px",
                        backgroundColor: "#d33333",
                        color: "#fff",
                        border: "none",
                        borderRadius: "25px",
                        cursor: "pointer",
                        fontSize: "18px",
                        fontWeight: "bold",
                      }}
                    >
                      <Typography>Register</Typography>
                    </Button>
                  </Card>
                </div>
              </div>
            </form>
          </Box>
        </div>
      )}

      {/* Modal for Adding Participant */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 3,
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            <h3>Add Other Participant</h3>
          </div>
          <Grid container spacing={2} sx={{ marginBottom: "10px" }}>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Salutation</label>
              <input
                className="ep-input form-control"
                name="salutation"
                value={participantInfo.salutation || ""}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Full Name (as per NRIC)</label>
              <input
                className="form-control"
                label="Name"
                name="name"
                placeholder="eg. Olivia Stan"
                fullWidth
                margin="normal"
                value={participantInfo.name}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>NRIC No.</label>
              <input
                className="form-control"
                label="IC"
                name="ic"
                placeholder="XXXXXX-XX-XXXX"
                fullWidth
                margin="normal"
                value={participantInfo.ic}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Email</label>
              <input
                className="form-control"
                label="Email"
                name="email"
                placeholder="example@gmail.com"
                fullWidth
                margin="normal"
                value={participantInfo.email}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Phone No.</label>
              <input
                className="form-control"
                label="Phone"
                name="phone"
                placeholder="+60xx-xxx-xxxx"
                fullWidth
                margin="normal"
                value={participantInfo.phone}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Designation</label>
              <input
                className="form-control"
                label="Designation"
                name="designation"
                placeholder="Company Staff"
                fullWidth
                margin="normal"
                value={participantInfo.designation}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>RPM No.</label>
              <input
                className="form-control"
                name="RPM_No"
                placeholder="xxxx"
                fullWidth
                margin="normal"
                value={participantInfo.RPM_No}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <label>Dietary Options</label>
              <Select
                className="ep-input form-select"
                name="dietary_option"
                value={participantInfo.dietary_option || ""}
                onChange={(event) =>
                  handleInputChange(event.target.value, "dietary_option")
                }
              >
                <MenuItem value="0">No Restriction</MenuItem>
                <MenuItem value="1">Vegetarian</MenuItem>
              </Select>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: " flex",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                className="add-button2"
                onClick={handleAddParticipant}
                sx={{ mt: 2 }}
              >
                Add This Participant
              </button>
            </div>
          </Grid>
        </Box>
      </Modal>

      {/* Modal for dietary */}
      <Modal open={openDietaryModal} onClose={() => setOpenDietaryModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
            p: 3,
          }}
        >
          <h3>Select Dietary Option</h3>
          <Select
            className="ep-input form-select"
            value={selectedDietaryOption}
            onChange={(event) => setSelectedDietaryOption(event.target.value)}
          >
            <MenuItem value="0">No Restriction</MenuItem>
            <MenuItem value="1">Vegetarian</MenuItem>
          </Select>
          <div
            style={{
              width: "100%",
              marginTop: "15px",
              display: " flex",
              justifyContent: "center",
            }}
          >
            <button
              type="button"
              className="add-button2"
              onClick={handleConfirmDietarySelection}
              sx={{ mt: 2 }}
            >
              Confirm
            </button>
          </div>
          {/* <button
            className="add-button2"
            onClick={handleConfirmDietarySelection}
          >
            Confirm
          </button> */}
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default EventPayment;
